module.exports = __webpack_public_path__ + "img/max-file-repeat--xml.f3388d93.svg";